// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { BreederRoleManagement, BreederRoleManagementSchema } from 'api/gen/BreederRoleManagement';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Username, UsernameSchema } from 'api/gen/Username';

const requiredPart = t.interface({
  isSubjectMember: t.boolean,
  roles: t.array(BreederRoleManagementSchema),
  userProfileId: t.Integer,
  username: UsernameSchema,
});

export const UserProfileSubjectRoleManagementDtoBreederRoleManagementSchema = excess(requiredPart);

export interface UserProfileSubjectRoleManagementDtoBreederRoleManagement extends t.TypeOf<typeof UserProfileSubjectRoleManagementDtoBreederRoleManagementSchema> {}
